import { AlertCircle } from 'lucide-react';
import { ReactNode } from 'react';

interface WarningMessageProps {
  children: ReactNode;
}

export function WarningMessage({ children }: WarningMessageProps) {
  return (
    <div className="p-3 bg-amber-50 text-amber-700 rounded-lg text-sm mt-2">
      <div className="flex items-start gap-2">
        <AlertCircle className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
        {children}
      </div>
    </div>
  );
}
